import { render } from "./ImageWithLabel.vue?vue&type=template&id=1240cbde&scoped=true&lang=html"
import script from "./ImageWithLabel.vue?vue&type=script&lang=js"
export * from "./ImageWithLabel.vue?vue&type=script&lang=js"

import "./ImageWithLabel.vue?vue&type=style&index=0&id=1240cbde&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1240cbde"]])

export default __exports__